import { z } from 'zod';

export const searchSchema = z.object({
  // Date range fields
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  // Document number range fields
  so_ct1: z.string().optional().nullable(),
  so_ct2: z.string().optional().nullable(),
  // Basic info fields
  ma_kh: z.string().optional(), // Supplier code
  tk: z.string().optional(), // Account code
  dien_giai: z.string().optional(), // Description
  // Detail fields
  ma_vt: z.string().optional(), // Material code
  ma_kho: z.string().optional(), // Warehouse code
  ma_lo: z.string().optional(), // Batch code
  ma_vi_tri: z.string().optional(), // Location code
  // Filter fields
  ma_unit: z.string().optional(), // Unit code
  status: z.string().optional(), // Status
  user_id0: z.string().optional() // Filter by user
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const formSchema = z.object({
  // BasicInfoTab fields
  ma_so_thue: z.string().optional(), // Mã số thuế
  ten_kh_thue: z.string().optional(), // Tên nhà cung cấp
  dia_chi: z.string().optional(), // Địa chỉ
  dien_giai: z.string().optional(), // Diễn giải
  ong_ba: z.string().optional(), // Người nhận
  e_mail: z.string().optional(), // Email
  ma_ct: z.string().optional(), // Mã chứng từ
  so_ct: z.string().optional(), // Số chứng từ
  ngay_ct: z.string().optional(), // Ngày chứng từ
  so_ct0: z.string().optional().nullable(), // Số hóa đơn
  so_ct2: z.string().optional().nullable(), // Ký hiệu
  ngay_ct0: z.string().optional(), // Ngày hóa đơn
  ma_nt: z.string().optional(), // Ngoại tệ
  ty_gia: z.coerce.number().optional(), // Tỷ giá
  status: z.string().optional(), // Trạng thái
  transfer_yn: z.boolean().optional(), // Dữ liệu nhận được

  // OtherTab fields
  ma_gd: z.string().optional(), // Giao dịch

  // BottomActionBarV2 fields
  t_cp_nt: z.coerce.number().optional(), // Tổng chi phí ngoại tệ
  t_cp: z.coerce.number().optional(), // Tổng chi phí
  t_thue_nt: z.coerce.number().optional(), // Tổng thuế ngoại tệ
  t_thue: z.coerce.number().optional(), // Tổng thuế
  t_tt_nt: z.coerce.number().optional(), // Tổng thanh toán ngoại tệ
  t_tt: z.coerce.number().optional(), // Tổng thanh toán

  unit_id: z.string().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  // BasicInfoTab fields
  ma_so_thue: '',
  ten_kh_thue: '',
  dia_chi: '',
  dien_giai: '',
  ong_ba: '',
  e_mail: '',
  ma_ct: 'HD4',
  so_ct: '',
  ngay_ct: new Date().toISOString(),
  so_ct0: '',
  so_ct2: '',
  ngay_ct0: new Date().toISOString(),
  ma_nt: '',
  ty_gia: 1,
  status: '5',
  transfer_yn: false,

  // OtherTab fields
  ma_gd: 'TN',

  // BottomActionBarV2 fields
  t_cp_nt: 0,
  t_cp: 0,
  t_thue_nt: 0,
  t_thue: 0,
  t_tt_nt: 0,
  t_tt: 0,

  unit_id: ''
};
